import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MultipleFilesSvg = function MultipleFilesSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.568 1.875H2.813v17.407h1.469V3.356h10.286zM13.65 14.468H9.056v-1.482h4.592zM9.057 18.171h8.266V16.69H9.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.25 4.653H5.568v17.222h15.245V9.253zm-9.213 15.74V6.134h8.604l3.702 3.733v10.526z",
    clipRule: "evenodd"
  }));
};
export var MultipleFiles = function MultipleFiles(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MultipleFilesSvg
  }));
};